import React from 'react';

const GoogleLogo: React.FC = () => {
  return (
    <svg
      width="35px"
      height="34px"
      viewBox="0 0 35 34"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="GoogleLogo"
    >
      <title id="GoogleLogo">Google</title>
      <path
        d="M7.21626906,17.5025602 C7.21626906,16.4382882 7.38371257,15.4177954 7.68292683,14.4607955 L2.44849726,10.2439024 C1.42830523,12.4290267 0.853658537,14.8914199 0.853658537,17.5025602 C0.853658537,20.1116524 1.42781989,22.5722534 2.44631321,24.7560976 L7.67783072,20.5310119 C7.38152852,19.5783643 7.21626906,18.5617118 7.21626906,17.5025602"
        fill="#FBBC05"
      />
      <path
        d="M18.8034808,6.86137119 C21.3537001,6.86137119 23.6571149,7.6999774 25.4669206,9.07214681 L30.7317073,4.19303105 C27.5235309,1.60095167 23.4103104,0 18.8034808,0 C11.6512325,0 5.50427489,3.79574136 2.56097561,9.34207318 L8.65173856,13.6585366 C10.0551922,9.70503243 14.0557411,6.86137119 18.8034808,6.86137119"
        fill="#EA4335"
      />
      <path
        d="M18.3879117,26.4313117 C13.7619194,26.4313117 9.86372571,23.5876505 8.49617982,19.6341463 L2.56097561,23.9498236 C5.42896974,29.4969416 11.4186557,33.2926829 18.3879117,33.2926829 C22.689215,33.2926829 26.7959801,31.8379632 29.8780488,29.112493 L24.2444201,24.9645371 C22.65482,25.9181896 20.6530299,26.4313117 18.3879117,26.4313117"
        fill="#34A853"
      />
      <path
        d="M34.1463415,16.8206417 C34.1463415,15.792876 33.991774,14.6860305 33.7600553,13.6585366 L17.9268293,13.6585366 L17.9268293,20.3781458 L27.0407438,20.3781458 C26.5849951,22.6692861 25.3447434,24.4305102 23.5697359,25.5767597 L28.9978918,29.8780488 C32.1173448,26.910518 34.1463415,22.4896581 34.1463415,16.8206417"
        fill="#4285F4"
      />
    </svg>
  );
};

export default GoogleLogo;
